<template>
    <InertiaLink :href="'/'">
        <LogoImg class="h-16" />
    </InertiaLink>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';
    import LogoImg from "../Components/LogoImg";

    export default defineComponent({
        components: {
            LogoImg,
            InertiaLink: Link,
        },
    })
</script>
